import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
type NavDrawerContextValue = {
  isOpen: boolean;
  open: (trigger?: HTMLElement | null) => void;
  close: () => void;
  triggerRef: React.MutableRefObject<HTMLElement | null>;
};
const NavDrawerContext = createContext<NavDrawerContextValue | null>(null);
export function NavDrawerProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef<HTMLElement | null>(null);
  const open = useCallback((trigger?: HTMLElement | null) => {
    triggerRef.current = trigger ?? null;
    setIsOpen(true);
  }, []);
  const close = useCallback(() => setIsOpen(false), []);
  return <NavDrawerContext.Provider value={{
    isOpen,
    open,
    close,
    triggerRef
  }} data-id="element-1069" data-mp="2ch0ali1ongs4">{children}</NavDrawerContext.Provider>;
}
export function useNavDrawer() {
  const ctx = useContext(NavDrawerContext);
  if (!ctx) throw new Error('useNavDrawer must be used within NavDrawerProvider');
  return ctx;
}